<lgb-header-gradient [height]="((binder()!=null)? 200 : 100)" [background]="binder()==null"></lgb-header-gradient>
<div class="screen-container">
	<form #form="ngForm" [loading]="loading()">
		<div class="img-container">
			<img [altImg]="getSrc()"/>
			<div class="img-icon">
				<a href="#" [routerLink]="router.get('admin-binder')" class="back add-fav glass rounded-full bg-black/40">
					<i class="fa-regular fa-chevron-left"></i>
				</a>
				<label for="img-binder" class="add-fav glass rounded-full bg-black/40 mb-3">
					<i class="fa-light fa-pen"></i>
				</label>
				<input (src)="setPreview($event)" (change)="setFile($event)" inputPreview id="img-binder" type="file" class="img-none"/>
			</div>
		</div>

		<div [ngClass]="{'mb-4': (error() || msg())}">
			<lgb-message [(error)]="error" [(msg)]="msg"></lgb-message>
		</div>

		<p class="element-info">
			<i class="text-primary fa-sharp fa-light fa-circle-info"></i>
			Taille de l'image : 1000 x 1014px
		</p>

		<!-- Marque -->
		<label class="floating-label my-4">
		  <span>Marque</span>
		  <input type="text" [(ngModel)]="binder().brand" placeholder="Marque" name="brand" class="input input-md w-full" required />
		</label>

		<!-- name -->
		<label class="floating-label my-4">
		  <span>Modèle</span>
		  <input type="text" [(ngModel)]="binder().name" placeholder="Modèle" name="name" class="input input-md w-full" required />
		</label>

		<!-- Référence fournisseur -->
		<label class="floating-label my-4">
		  <span>Référence fournisseur</span>
		  <input type="text" [(ngModel)]="binder().refProvider" placeholder="Référence fournisseur" name="refProvider" class="input input-md w-full" required />
		</label>

		<!-- nbPage -->
		<label class="floating-label my-4">
		  <span>Nombre de pages</span>
		  <input type="number" [(ngModel)]="binder().nbPage" placeholder="Nombre de pages" name="nbPage" class="input input-md w-full" required />
		</label>

		<!-- width -->
		<label class="floating-label my-4">
		  <span>Width</span>
		  <input type="text" [(ngModel)]="binder().width" placeholder="Width" name="width" class="input input-md w-full" required />
		</label>

		<!-- height -->
		<label class="floating-label my-4">
		  <span>Height</span>
		  <input type="text" [(ngModel)]="binder().height" placeholder="Height" name="height" class="input input-md w-full" required />
		</label>

		<!-- nbCard -->
		<label class="floating-label my-4">
		  <span>Nombre de cartes</span>
		  <input type="text" [value]="nbCard()" placeholder="Nombre de cartes" class="input input-md w-full" disabled />
		</label>

		<!-- nbScan -->
		<label class="floating-label my-4">
		  <span>Nombre de scans</span>
		  <input type="text" [value]="nbScan()" placeholder="Nombre de scans" class="input input-md w-full" disabled />
		</label>

		@if(!isNew()){
			<a href="#" onclick="my_modal_1.showModal(); return false;" class="link-gen text-primary">
				<!-- <a class="btn btn-square btn-ghost add-btn text-primary my-4"> -->
				<i class="gen-icon fa-light fa-file-zipper mr-2"></i> Generer des binders
			</a>
		}

		<div class="btn-container mt-4" [ngClass]="{'btn-continer-serial': !isNew()}">
			@if(!isNew()){
				<button (click)="rm()" class="btn btn-soft btn-error">
					Supprimer
				</button>
			}
			<button (click)="setBinder()" class="btn btn-primary btn-gradient" [disabled]="form.invalid">
				{{((isNew())? 'Ajouter' : 'Modifier')}}
			</button>
		</div>
	</form>
	<dialog id="my_modal_1" class="modal">
	  <div class="modal-box">
	    <div class="">
	    	Génération de binders
	    </div>
	    <div>
			<!-- qte -->
			<label class="floating-label my-4">
			  <span>Nombre de binders</span>
			  <input type="number" [(ngModel)]="nbBinder" placeholder="Nombre de binders" name="nbBinder" class="input input-md w-full" required />
			</label>

			<div>
				<input type="checkbox" [(ngModel)]="showCode" name="showCode" class="ml-2 toggle border-white-600 bg-white-500 checked:border-indigo-500 checked:bg-indigo-400 checked:text-indigo-800" />
				Afficher le code
			</div>
	    </div>
	    <div class="modal-action">
	      <form method="dialog">
	        <!-- if there is a button in form, it will close the modal -->
	        <button class="btn">Retour</button>
	        <button (click)="bucket()" class="btn btn-primary btn-gradient">Générer</button>
	      </form>
	    </div>
	  </div>
	</dialog>
</div>
